import ClientSDK from "../../App/ClientSDK";

class DepositDataStore
{
    static getDeposits(offset, limit, sorting)
    {
        let params = new URLSearchParams();
        if (offset) params.append('page[offset]', offset);
        if (limit) params.append('page[limit]', limit);
        if (sorting) {
            let fields = [];
            for (let field in sorting) {
                if (! sorting.hasOwnProperty(field)) continue;

                fields.push(sorting[field] === 'DESC' ? '-' + field : field)
            }
            params.append('sort', fields.join(','))
        }

        let url = 'deposits?' + params.toString();

        return ClientSDK.instance().get(url);
    }
}

export default DepositDataStore;